module.exports = __webpack_public_path__ + "static/img/xueshu3.e6bb8d57.webp";